import React, { useState, useRef } from 'react'
import { CgChevronDown, CgChevronRight, CgMailReply } from 'react-icons/cg'
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
  Typography,
} from '@material-tailwind/react'
import SmartLink from '@components/SmartLink/SmartLink'
import GatsbyMediaByName from '@components/GatsbyMediaByName'

export function NavigationMobile({ onNavChange, menus = [] }) {
  const dropmenuRef = useRef(null)
  const [open, setOpen] = React.useState('')
  const [activeCategory, setActiveCategory] = useState(null)
  const handleOpen = (value) => {
    setOpen(open === value ? '' : value)
  }

  const closePanel = () => {
    setOpen('')
    setActiveCategory(null)
    onNavChange && onNavChange()
  }

  const checkHasChildren = (array) => {
    return array.find(
      (item) => Array.isArray(item.children) && item.children.length > 0,
    )
  }

  // 渲染缩略图的辅助函数
  const renderThumbnail = (thumbnailName, title, className = '') => {
    if (!thumbnailName) return null

    // 如果包含 http，使用 img 标签
    if (thumbnailName.includes('http')) {
      return <img src={thumbnailName} alt={title} className={className} />
    }

    // 否则使用 GatsbyMediaByName
    return (
      <GatsbyMediaByName
        name={thumbnailName}
        className={className}
        alt={title}
      />
    )
  }

  const menuLinkItem = (item) => {
    const { title, link, description, thumbnailName } = item
    return (
      <SmartLink
        className="flex bg-white mx-[0.75rem] items-center  py-[0.5rem] px-2 rounded-[2px] my-2"
        to={link}
        callback={closePanel}
      >
        <span>
          {thumbnailName &&
            renderThumbnail(thumbnailName, title, 'w-[15vw] mr-4')}
        </span>
        <div>
          <Typography className="text-fluid-sm font-medium">{title}</Typography>
          <Typography className="text-fluid-sm">{description}</Typography>
        </div>
      </SmartLink>
    )
  }

  const categoryRender = (list = [], index) => {
    const hasChildren = checkHasChildren(list)
    return (
      <div className="manus-panel overflow-hidden">
        {(list || []).map((item, index) => {
          const { title, link, children, thumbnailName, description } = item
          const openKey = `title${index}`
          const itemHasChildren = children && children.length > 0
          return hasChildren ? (
            <Accordion
              key={`accordion-${index}`}
              open={open === openKey}
              icon={
                itemHasChildren ? (
                  <CgChevronDown
                    className={`!text-fluid-base transition ${openKey === open ? 'rotate-180' : ''}`}
                  />
                ) : null
              }
            >
              <AccordionHeader
                className="!text-fluid-sm font-normal border-none responsive-frame bg-white"
                onClick={() => itemHasChildren && handleOpen(openKey)}
              >
                <div>
                  {thumbnailName &&
                    renderThumbnail(thumbnailName, title, 'w-[15vw] mr-2')}
                  {link ? (
                    <SmartLink to={link} callback={closePanel}>
                      {title}
                    </SmartLink>
                  ) : (
                    title
                  )}
                  {description && (
                    <Typography
                      className="text-fluid-xs font-light"
                      variant="h6"
                    >
                      {description}
                    </Typography>
                  )}
                </div>
              </AccordionHeader>
              {children && (
                <AccordionBody>{categoryRender(children)}</AccordionBody>
              )}
            </Accordion>
          ) : (
            menuLinkItem(item)
          )
        })}
      </div>
    )
  }
  return (
    <div
      ref={dropmenuRef}
      className="overflow-auto bg-white text-[--grey-90]"
      style={{
        height: `calc(100vh - ${dropmenuRef.current?.offsetTop}px)`,
      }}
    >
      {activeCategory ? (
        <>
          <div className="categroy-menu-container responsive-frame flex justify-between items-center border-y-[1px] border-gray-100 py-[0.5em]">
            <span>
              {activeCategory.thumbnailName &&
                renderThumbnail(
                  activeCategory.thumbnailName,
                  activeCategory.title,
                  'w-[10vw]',
                )}
              {activeCategory.link ? (
                <SmartLink
                  className="!text-fluid-sm font-semibold"
                  to={activeCategory.link}
                  callback={closePanel}
                >
                  {activeCategory.title}
                </SmartLink>
              ) : (
                <Typography
                  className="!text-fluid-sm font-semibold"
                  variant="h6"
                >
                  {activeCategory.title}
                </Typography>
              )}
            </span>
            <CgMailReply onClick={() => setActiveCategory(null)} />
          </div>
          <div className="bg-[--grey-30]">
            {categoryRender(activeCategory.children)}
          </div>
        </>
      ) : (
        <ul className="responsive-frame">
          {menus.map((item, index) => {
            const { title, link, children, thumbnailName } = item
            const hasChildren = children && children.length > 0
            return (
              <li
                key={index}
                className="flex justify-between text-fluid-sm font-semibold py-[1em]"
                onClick={() => hasChildren && setActiveCategory(item)}
              >
                {hasChildren ? (
                  <>
                    <span>
                      {thumbnailName &&
                        renderThumbnail(thumbnailName, title, 'w-[15vw]')}
                      {link ? (
                        <SmartLink to={link} callback={closePanel}>
                          {title}
                        </SmartLink>
                      ) : (
                        title
                      )}
                    </span>
                    <CgChevronRight className="text-fluid-sm font-semibold" />
                  </>
                ) : link ? (
                  <SmartLink className="w-full" to={link} callback={closePanel}>
                    <>
                      {thumbnailName &&
                        renderThumbnail(thumbnailName, title, 'w-[15vw]')}
                      {title}
                    </>
                  </SmartLink>
                ) : (
                  <>
                    {thumbnailName &&
                      renderThumbnail(thumbnailName, title, 'w-[15vw]')}
                    {title}
                  </>
                )}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
